import '../../styles.scoped.css'
import {Typography, TextField, Link, Button} from '@mui/material'
import {UploadFile, Edit} from '@mui/icons-material'
import {useDropzone} from 'react-dropzone'
import FieldLabel from '../FieldLabel'

// The picked logo is only held here; it is uploaded once the organization
// exists, on the last step.
export default ({form, logoUrl, setLogoUrl, setLogoFile}) => {
    const errors = form.formState.errors
    const {getRootProps, getInputProps, isDragActive, open} = useDropzone({
        accept: {'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.svg']},
        noClick: true,
        multiple: false,
        maxSize: 3 * 1024 * 1024,
        onDrop: acceptedFiles => {
            if (!acceptedFiles[0]) return
            setLogoFile(acceptedFiles[0])
            setLogoUrl(URL.createObjectURL(acceptedFiles[0]))
        },
    })

    const text = (name, label, placeholder, {required} = {}) => (
        <div className="field">
            <FieldLabel required={required}>{label}</FieldLabel>
            <TextField placeholder={placeholder} fullWidth {...form.register(name)} error={!!errors?.[name]} helperText={errors?.[name]?.message} />
        </div>
    )

    return (
        <>
            <Typography variant="h6" color="text.primary">
                General Information
            </Typography>
            <Typography className="panel-subtitle" variant="body2" color="text.secondary">
                Basic identity and tax details for the healthcare organization.
            </Typography>
            <div className="logo-row">
                <div className="form-left">
                    <FieldLabel>Healthcare Logo</FieldLabel>
                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        {logoUrl ? (
                            <div className="logo-preview">
                                <img src={logoUrl} height={80} alt="Healthcare logo preview" />
                                <Button size="small" startIcon={<Edit fontSize="small" />} onClick={open}>
                                    Change
                                </Button>
                            </div>
                        ) : (
                            <div
                                style={{
                                    backgroundColor: isDragActive ? '#e3f2fd' : '#fbfbfb',
                                    border: '1px dashed #0000001F',
                                    borderRadius: 4,
                                    height: 120,
                                    boxSizing: 'border-box',
                                    textAlign: 'center',
                                    paddingTop: 20,
                                }}
                            >
                                <UploadFile style={{fontSize: 26}} color="primary" />
                                <Typography variant="body1" color="text.primary" style={{marginTop: 8, marginBottom: 8}}>
                                    <Link underline="always" onClick={open} style={{cursor: 'pointer'}}>
                                        Click to upload
                                    </Link>{' '}
                                    or drag and drop
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    SVG, PNG, JPG or GIF (max. 3MB)
                                </Typography>
                            </div>
                        )}
                    </div>
                </div>
                <div className="form-right">{text('name', 'Healthcare Name', 'Enter the healthcare name', {required: true})}</div>
            </div>
            {text('email', 'Healthcare Email', 'Enter the healthcare email', {required: true})}
            {text('phone', 'Healthcare Phone Number', 'Enter the healthcare phone number', {required: true})}
            {text('npi', 'Organization NPI', 'Enter the organization NPI')}
            <div className="form">
                <div className="form-left">{text('tin', 'US Taxpayer ID (TIN)', 'Enter the US taxpayer ID')}</div>
                <div className="form-right">{text('federal_tax_id', 'Federal Tax ID (EIN)', 'e.g. 12-3456789')}</div>
            </div>
        </>
    )
}
